(function () {
  const el = document.querySelector('[data-djh-metals-price]');
  const configEl = document.querySelector('[data-djh-metals-config]');
  if (!el || !configEl) return;

  let config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (_err) {
    return;
  }
  if (!config.endpoint) return;

  fetch(config.endpoint, { credentials: 'omit' })
    .then((res) => (res.ok ? res.json() : Promise.reject(res.status)))
    .then((data) => {
      if (!data || typeof data.gold !== 'number') return;
      el.querySelectorAll('[data-djh-metal]').forEach((node) => {
        const key = node.getAttribute('data-djh-metal');
        if (typeof data[key] === 'number') {
          // minimumFractionDigits AS WELL AS maximum, or the three prices print in
          // three formats. en-US defaults the minimum to 0, so a max of 2 alone gave
          // "$4,465.2", "$1,840" and "$66.74" side by side on one line about money —
          // and $4,465.2 does not read as a price, it reads as a truncation.
          node.textContent =
            '$' +
            data[key].toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
        }
      });
      el.hidden = false;
    })
    .catch(() => {
      // Fails silently — the ticker just stays hidden. Not worth surfacing an
      // error to shoppers over a footer market-price display.
    });
})();
